import { Form as AntForm } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Form } from 'components/atoms/form';
import { Input } from 'components/atoms/input';
import { Modal } from 'components/atoms/modal';
import { useTranslation } from 'hooks/use-translation';

const { Item } = AntForm;

interface FormValues {
  url: string;
  spaceTabTitle: string;
}

interface Props {
  isModalVisible: boolean;
  isLoading?: boolean;
  initialValues: FormValues;
  onFinish: (val: FormValues) => Promise<void>;
  onCancel: () => void;
}

export const EmbedSpaceTabEditModal: FC<Props> = ({
  isModalVisible,
  isLoading,
  initialValues,
  onFinish,
  onCancel,
}) => {
  const placeholder = useTranslation('space_tab.embed.input.placeholder');
  const label = useTranslation('space_tab.embed.input.label');
  const titleInputLabel = useTranslation('title');
  const errorMessage = useTranslation('input.required');
  const urlErrorMessage = useTranslation('input.url');
  const [form] = Form.useForm();

  return (
    <Modal
      destroyOnClose
      forceRender
      visible={isModalVisible}
      title={<FormattedMessage id="space_tab.edit" />}
      confirmLoading={false}
      onCancel={onCancel}
      okButtonProps={{
        onClick: form.submit,
        loading: isLoading,
      }}
    >
      <Form
        form={form}
        onFinish={(val) => onFinish(val as FormValues)}
        layout="vertical"
        name="embed"
        initialValues={initialValues}
      >
        <Item
          hasFeedback
          label={titleInputLabel}
          name="spaceTabTitle"
          rules={[{ required: true, message: errorMessage }]}
        >
          <Input name="spaceTabTitle" />
        </Item>

        <Item
          hasFeedback
          label={label}
          name="url"
          rules={[
            { required: true, message: errorMessage },
            {
              pattern: /^https?:\/\//i,
              message: urlErrorMessage,
            },
          ]}
        >
          <Input name="url" type="url" placeholder={placeholder} />
        </Item>
      </Form>
    </Modal>
  );
};
